import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, catchError, forkJoin, map, of } from 'rxjs';
import { QuestionsService } from '../../home/services/questions.service';

@Injectable()
export class AppTranslateLoader implements TranslateLoader {
    private readonly http = inject(HttpClient);
    private readonly questionsService = inject(QuestionsService);

    public getTranslation(lang: string): Observable<TranslationObject> {
        const baseTranslations$ = this.http.get<TranslationObject>(`assets/i18n/${lang}.json`);
        const questionTranslations$ = this.questionsService.getQuestionTranslations(lang);

        return forkJoin({
            baseTranslations: baseTranslations$,
            questionTranslations: questionTranslations$
        }).pipe(
            map(({ baseTranslations, questionTranslations }) => ({
                ...baseTranslations,
                ...questionTranslations
            })),
            catchError(() => of({} as TranslationObject))
        );
    }
}
